import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import apiService from "../services/apiService";
import AddUserForm from "./AddUserForm";
import { Edit, Trash } from "lucide-react";

const Dashboard = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [users, setUsers] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [userToEdit, setUserToEdit] = useState(null);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [userIdToDelete, setUserIdToDelete] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalUsers, setTotalUsers] = useState(0);
  const limit = 20;

  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      setIsLoggedIn(true);
      fetchUsers();
    } else {
      navigate("/");
    }
  }, [navigate, currentPage]);

  const fetchUsers = async () => {
    try {
      const response = await apiService.postData("admin/user-list", {
        limit: limit,
        offset: (currentPage - 1) * limit,
      });

      if (!response.error && response.data?.rows) {
        setUsers(response.data.rows);
        setTotalUsers(response.data.count || response.data.Count); // Handle different key cases
      }
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  const handleEdit = (user) => {
    setUserToEdit(user);
    setShowForm(true);
  };

  const confirmDeleteUser = (id) => {
    setUserIdToDelete(id);
    setIsDeleteModalOpen(true);
  };

  const handleDelete = async () => {
    try {
      await apiService.postData("admin/delete-user", {
        user_id: userIdToDelete,
      });
      fetchUsers();
      setIsDeleteModalOpen(false);
    } catch (error) {
      console.error("Error deleting user:", error);
    }
  };

  // Calculate total pages
  const totalPages = totalUsers > 0 ? Math.ceil(totalUsers / limit) : 1;
  const isNextDisabled = users.length < limit || currentPage * limit >= totalUsers;

  return (
    isLoggedIn && (
      <div className="container mt-4">
        <main>
          {showForm ? (
            <AddUserForm
              fetchUsers={fetchUsers}
              userToEdit={userToEdit}
              closeForm={() => setShowForm(false)}
            />
          ) : (
            <div className="card">
              <div className="card-header d-flex justify-content-between align-items-center">
                <h4>User List</h4>
                {/* <button
                  onClick={() => {
                    setShowForm(true);
                    setUserToEdit(null);
                  }}
                  className="btn btn-danger"
                >
                  Add User <i className="fas fa-plus"></i>
                </button> */}
              </div>
              <div className="card-body p-0">
                <div className="table-responsive">
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        {/* <th>Name</th> */}
                        <th>Mobile Number</th>
                        <th>Device Id</th>
                        <th style={{ width: "150px" }}>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {users.length > 0 ? (
                        users.map((user) => (
                          <tr key={user.user_id}>
                            {/* <td>{user.name}</td> */}
                            <td>{user.mobile}</td>
                            <td>{user.deviceId || "-"}</td>
                            <td>
                              {/* <button
                                onClick={() => handleEdit(user)}
                                className="btn btn-primary btn-sm text-white me-2"
                              >
                                <Edit size={16} />
                              </button> */}
                              <button
                                onClick={() => confirmDeleteUser(user.user_id)}
                                className="btn btn-danger btn-sm text-white"
                              >
                                <Trash size={16} />
                              </button>
                            </td>
                            {/* <td>
  <div className="dropdown">
    <button
      className="btn btn-outline-primary btn-sm dropdown-toggle"
      type="button"
      id={`dropdownMenuButton${user.user_id}`}
      data-bs-toggle="dropdown"
      aria-expanded="false"
    >
      Action
    </button>
    <ul
      className="dropdown-menu"
      aria-labelledby={`dropdownMenuButton${user.user_id}`}
    >
      <li>
        <button
          className="dropdown-item"
          onClick={() => handleEdit(user)}
        >
          <Edit size={14} className="me-2" />
          Edit
        </button>
      </li>
      <li>
        <button
          className="dropdown-item text-danger"
          onClick={() => confirmDeleteUser(user.user_id)}
        >
          <Trash size={14} className="me-2" />
          Delete
        </button>
      </li>
    </ul>
  </div>
</td> */}

                          </tr>
                        ))
                      ) : currentPage === 1 ? (
                        <tr>
                          <td colSpan="4" className="text-center">
                            No users found.
                          </td>
                        </tr>
                      ) : null}
                    </tbody>
                  </table>
                </div>

                {/* Pagination */}
                <nav className="d-flex justify-content-center align-items-center my-3">
                  <button
                    className={`btn btn-outline-primary me-2 ${
                      currentPage === 1 ? "disabled" : ""
                    }`}
                    onClick={() => setCurrentPage(currentPage - 1)}
                    disabled={currentPage === 1}
                  >
                    «
                  </button>
                  {Array.from({ length: totalPages }, (_, index) => (
                    <button
                      key={index + 1}
                      className={`btn mx-1 ${
                        currentPage === index + 1
                          ? "btn-primary"
                          : "btn-outline-primary"
                      }`}
                      onClick={() => setCurrentPage(index + 1)}
                    >
                      {index + 1}
                    </button>
                  ))}
                  <button
                    className={`btn btn-outline-primary ms-2 ${
                      isNextDisabled ? "disabled" : ""
                    }`}
                    onClick={() => setCurrentPage(currentPage + 1)}
                    disabled={isNextDisabled}
                  >
                    »
                  </button>
                </nav>
              </div>
            </div>
          )}
        </main>

        {/* Delete Confirmation Modal */}
        {isDeleteModalOpen && (
          <div className="modal fade show d-block" tabIndex="-1">
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Confirm Delete</h5>
                  <button
                    className="btn-close"
                    onClick={() => setIsDeleteModalOpen(false)}
                  ></button>
                </div>
                <div className="modal-body">
                  <p>Are you sure you want to delete this user?</p>
                </div>
                <div className="modal-footer">
                  <button className="btn btn-danger" onClick={handleDelete}>
                    Yes
                  </button>
                  <button
                    className="btn btn-secondary"
                    onClick={() => setIsDeleteModalOpen(false)}
                  >
                    No
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    )
  );
};

export default Dashboard;
